export const IssueTypes = {
    Incident: 1,
    Change: 2,
    Issue: 3,
    Project: 4
}
